export const LOCALES = {
    ENGLISH: 'en-us',
    FRENCH: 'fr-ca',
};